import { render, staticRenderFns } from "./DocumentDetail.component.pug?vue&type=template&id=49ea87f0&scoped=true&lang=pug&"
import script from "./DocumentDetail.component.ts?vue&type=script&lang=ts&"
export * from "./DocumentDetail.component.ts?vue&type=script&lang=ts&"
import style0 from "./DocumentDetail.component.scss?vue&type=style&index=0&id=49ea87f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea87f0",
  null
  
)

export default component.exports